import { cva } from "class-variance-authority";

interface CounterMetricProps {
  value: string | number;
  prefix?: string;
  suffix?: string;
}

const counterMetricVariants = cva("", {
  variants: {
    part: {
      affix: "font-bold text-[30px] leading-[32px]",
      value: "text-[132px] leading-[140px]",
    },
  },
});

export function CounterMetric(props: Readonly<CounterMetricProps>) {
  return (
    <div className="flex items-center justify-center gap-1 leading-none">
      {props.prefix ? (
        <span className={counterMetricVariants({ part: "affix" })}>
          {props.prefix}
        </span>
      ) : null}
      <span
        className={counterMetricVariants({ part: "value" })}
        data-animate-numbers
      >
        {props.value}
      </span>
      {props.suffix ? (
        <span className={counterMetricVariants({ part: "affix" })}>
          {props.suffix}
        </span>
      ) : null}
    </div>
  );
}
